// extracted by mini-css-extract-plugin
export default {"cls1":"upPOtuzV2SL7qykO0CcW","cls2":"NUROQ2tBmchJM91Bmte6 upPOtuzV2SL7qykO0CcW"};